<template>
  <el-row >
    <el-row  :gutter="1" style="padding-top: 30px;margin-bottom: 10px" type="flex" class="row-bg" justify="center" >
    <el-col  class="one"  :xs="22" :sm="22" :md="22" :lg="18" :xl="18" >
      <div style="margin: 3px;background: #eef1f6;height: 40px"><h5 style="margin: 0px;padding-left: 10px">Search by options:</h5></div>
      <div style="margin-left: 3px;margin-right: 3px;margin-bottom: 20px;background: #FFFFFF"><td>Users can search by "Keyword", "Vivo/Vitro", "Component type", "RNA species", "RNA type". The "Keyword" could be "RNA symbol", "Protein name" or "Vrius". All data will be returned if you do not restrict the search.</td></div>

      <el-form :model="form" label-width="150px" size="mini" style="font-size: 0.8rem">
        <el-row :gutter="1" type="flex" class="row-bg" justify="center">
          <el-col :xs="22" :sm="22" :md="22" :lg="18" :xl="18">
            <el-form-item label="Keyword">
              <el-select v-model="form.key1"  style="width: 120px;margin-right: 5px">
                <el-option label="All" value=""></el-option>
                <el-option label="RNA symbol" value="RNA"></el-option>
                <el-option label="Protein name" value="Protein"></el-option>
                <el-option label="Virus" value="Virus"></el-option>
              </el-select>
              <el-autocomplete
                  class="inline-input"
                  v-model="form.key2"
                  style="width: 150px"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter="1" type="flex" class="row-bg" justify="center">
          <el-col :xs="11" :sm="11" :md="11" :lg="9" :xl="9">
            <el-form-item label="Vivo/Vitro" prop="in_vitrovivo">
              <el-select v-model="form.in_vitrovivo"  placeholder="All" @change="changevv">
                <el-option label="All" value=""></el-option>
                <el-option label="In vivo" value="In vivo"></el-option>
                <el-option label="In vitro" value="In vitro"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="RNA species" prop="source">
              <el-select v-model="form.source"  placeholder="All">
                <el-option label="All" value=""></el-option>
                <el-option label="Homo sapiens" value="Homo sapiens"></el-option>
                <el-option label="Mus musculus" value="Mus musculus"></el-option>
                <el-option label="Drosophila melanogaster" value="Drosophila melanogaster"></el-option>
                <el-option label="Xenopus laevis" value="Xenopus laevis"></el-option>
                <el-option label="virus" value="virus"></el-option>
                <el-option label="Saccharomyces cerevisiae" value="Saccharomyces cerevisiae"></el-option>
                <el-option label="Caenorhabditis elegans" value="Caenorhabditis elegans"></el-option>
                <el-option label="Escherichia coli" value="Escherichia coli"></el-option>
                <el-option label="Photinus pyralis" value="Photinus pyralis"></el-option>
                <el-option label="Triticum aestivum" value="Triticum aestivum"></el-option>
                <el-option label="Torula yeast" value="Torula yeast"></el-option>
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :xs="11" :sm="11" :md="11" :lg="9" :xl="9">

            <el-form-item label="Component type" prop="components_type" >
              <el-select v-model="form.components_type" :disabled="form.dis" placeholder="Apply to vitro">
                <el-option label="All" value=""></el-option>
                <el-option label="RNA(s)" value="RNA(s)"></el-option>
                <el-option label="RNAs+protein(s)" value="RNAs+protein"></el-option>
                <el-option label="RNA+protein(s)" value="RNA+protein"></el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="RNA type" prop="rna_classification">
              <el-select v-model="form.rna_classification"  placeholder="All">
                <el-option label="All" value=""></el-option>
                <el-option label="mRNA" value="mRNA"></el-option>
                <el-option label="lncRNA" value="LncRNA"></el-option>
                <el-option label="miRNA" value="miRNA"></el-option>
                <el-option label="rRNA" value="rRNA"></el-option>
                <el-option label="siRNA" value="siRNA"></el-option>
                <el-option label="snRNA" value="snRNA"></el-option>
                <el-option label="snoRNA" value="snoRNA"></el-option>
                <el-option label="piRNA" value="piRNA"></el-option>
                <el-option label="total RNA" value="total RNA"></el-option>
                <el-option label="virus RNA" value="virus RNA"></el-option>
                <el-option label="Poly" value="poly"></el-option>
                <el-option label="repeat RNA" value="repeat RNA"></el-option>
                <el-option label="irregular RNA" value="irregular RNA"></el-option>
                <el-option label="nucleotide rich RNA" value="nucleotide rich RNA"></el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>

      </el-form>

      <div style="display:flex;justify-content:center;align-items:center;margin-bottom: 10px">
        <el-button  size="mini" type="primary" @click="search">Search</el-button>
        <el-button  size="mini" type="danger" @click="example1">Reset</el-button>
      </div>
      <div style="display:flex;justify-content:center;align-items:center;margin-bottom: 10px">
        <el-button  size="mini" type="success" @click="example3" plain round>Example1</el-button>
        <el-button  size="mini" type="success" @click="example4" plain round>Example2</el-button>
        <el-button  size="mini" type="success" @click="example5" plain round>Example3</el-button>
      </div>


    </el-col>
    </el-row>

    <el-row :gutter="1" type="flex" class="row-bg" justify="center">
      <el-col class="two" :span="23">
        <div style="margin: 3px;background: #eef1f6;height: 40px"><h5 style="margin: 0px;padding-left: 10px">Search result:</h5></div>
        <div style="margin: 3px">
        <el-table
            :data="tableData.slice((currpage - 1) * pagesize, currpage * pagesize)"
            @sort-change="sort_change"
            style="width: 100%"
            :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'0.6rem'}"
            :cell-style="{fontSize: '0.6rem'}"
            stripe
            highlight-current-row
            border
        >
          <el-table-column
              prop="Psid"
              label="RPSID"
              align= "center"
              sortable
          >
            <template slot-scope="scope">
              <router-link  target="_blank" v-bind:to="/Detail/+scope.row.Psid">{{scope.row.Psid}}</router-link>
            </template>

          </el-table-column>

          <el-table-column
              prop="Nucleic_acid"
              label="RNA(s)"
              align= "center"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="RNA_len"
              label="RNA length"
              align= "center"
              sortable
          >
            <template slot-scope="scope">
              <a style="color: #606266">{{scope.row.RNA_length}}</a>
            </template>
          </el-table-column>
          <el-table-column
              prop="Rna_classification"
              label="RNA type"
              align= "center"
              sortable
          >

          </el-table-column>
          <el-table-column
              prop="Rna_source"
              label="RNA species"
              align= "center"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="Protein_name"
              label="Protein name"
              align= "center"
              sortable
              v-if="show"
          >

          </el-table-column>
          <el-table-column
              prop="Components_type"
              label="Component type"
              align= "center"
              sortable
          >

          </el-table-column>
          <el-table-column
              prop="Vivo_or_vitro"
              label="Vivo/Vitro"
              align= "center"
              sortable
          >
          </el-table-column>

        </el-table>
        <div style="padding: 6px"></div>
        <el-pagination background
                       layout="prev, pager, next, sizes, total, jumper"
                       :page-sizes="[5, 10, 15, 20]"
                       :page-size="pagesize"
                       :current-page="currpage"
                       :total="tableData.length"
                       @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"
                       small
        >
        </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-row  :gutter="1" type="flex" class="row-bg" justify="center" style="margin-bottom: 30px;margin-top: 30px">
      <el-col class="three" :xs="22" :sm="22" :md="22" :lg="18" :xl="18">
        <div style="margin: 3px;background: #eef1f6;height: 40px"><h5 style="margin: 0px;padding-left: 10px">Search by RNA sequence:</h5></div>
        <div style="margin-left: 3px;margin-right: 3px;margin-bottom: 10px;background: #FFFFFF"><td>Input RNA sequence below.</td></div>
        <el-form :model="bform"  size="mini" style="font-size: 0.8rem">
          <el-row :gutter="1">
            <el-col :span="16" :offset="4">
              <el-form-item label="" prop="Sequence" >
                <el-input type="textarea" v-model="bform.Sequence" placeholder="RNA sequence" :rows="5" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div style="display:flex;justify-content:center;align-items:center;margin-bottom: 10px">
          <el-button  size="mini" type="primary" @click="blast('bform')">Blast</el-button>
          <el-button size="mini" type="danger" @click="example2">Reset</el-button>
        </div>


      </el-col>
    </el-row>

    <el-row  :gutter="1" type="flex" class="row-bg" justify="center">
      <el-col class="four" :span="23">
        <div style="margin: 3px;background: #eef1f6;height: 40px"><h5 style="margin: 0px;padding-left: 10px">Search Result:</h5></div>
        <div style="margin: 3px">

          <el-table
              :data="bdata.slice((currpage - 1) * pagesize, currpage * pagesize)"
              @sort-change="sort_change"
              style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'0.8rem'}"
              :cell-style="{fontSize: '0.8rem'}"
              stripe
              highlight-current-row
              border
              :default-sort ="{prop:'score',order:'descending'}"
          >
            <el-table-column
                prop="Psid"
                label="RNAPSID"
                align= "center"
                sortable

            >
              <template slot-scope="scope">
                <router-link  target="_blank" v-bind:to="/Detail/+scope.row.Psid">{{scope.row.Psid}}</router-link>
              </template>

            </el-table-column>
            <el-table-column
                prop="E_value"
                label="E-value"
                align= "center"
                sortable

            >
            </el-table-column>

            <el-table-column
                prop="score"
                label="Score"
                align= "center"
                sortable

            >
            </el-table-column>

            <el-table-column
                prop="Nucleic_acid"
                label="RNA"
                align= "center"
                sortable

            >
            </el-table-column>
            <el-table-column
                prop="RNA_len"
                label="RNA length"
                align= "center"
                sortable
            >
              <template slot-scope="scope">
                <a style="color: #606266">{{scope.row.RNA_length}}</a>
              </template>
            </el-table-column>
            <el-table-column
                prop="Rna_classification"
                label="RNA type"
                align= "center"
                sortable
            >

            </el-table-column>
            <el-table-column
                prop="Rna_source"
                label="RNA species"
                align= "center"
                sortable

            >
            </el-table-column>

            <el-table-column
                prop="Protein_name"
                label="Protein name"
                align= "center"
                sortable

            >

            </el-table-column>
            <el-table-column
                prop="Components_type"
                label="Component type"
                align= "center"
                sortable
            >

            </el-table-column>
            <el-table-column
                prop="Vivo_or_vitro"
                label="Vivo/Vitro"
                align= "center"
                sortable
                width="110"


            >
            </el-table-column>


          </el-table>
          <div style="padding: 6px"></div>
          <el-pagination background
                         layout="prev, pager, next, sizes, total, jumper"
                         :page-sizes="[5, 10, 15, 20]"
                         :page-size="pagesize"
                         :current-page="currpage"
                         :total="tableData.length"
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         small
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

  </el-row>

</template>

<script>
import {search,blast} from "@/network/Search";

export default {
name: "Search",
  data() {
    return {
      tableData: [],
      bdata:[],
      pagesize:10,
      currpage:1,
      proptype: "",
      show:true,
      form:{
        rnas:'',
        components_type:null,
        in_vitrovivo:'',
        source:'',
        rna_classification:'',
        Protein:'',
        rp:'',
        virus:'',
        key1:'RNA',
        key2:'MAPT',
        dis:true
      },
      bform:{
        Sequence:'GGGGAAUUGUGAGCGGAUAACAAUUCCCCUCUAGAAAUAAUUUUGUUUAACUUUAAGAAGGAGAUAUACCAUGGGCAGCAGCCAUCAUCAUCAUCAUCACCACCACCACCAUAGCAGCGGCCUGGUGCCGCGCGGCAGCGCUAGCAUGUCUGAUAAUGGACCCCAAAAUCAGCGAAAUGCACCCCGCAUUACGUUUGGUGGACCCUCAGAUUCAACUGGCAGUAACCAGAAUGGAGAACGCAGUGGGGCGCGAUCAAAACAACGUCGGCCCCAAGGUUUACCCAAUAAUACUGCGUCUUGGUUCACCGCUCUCACUCAACAUGGCAAGGAAGACCUUAAAUUCCCUCGAGGACAAGGCGUUCCAAUUAACACCAAUAGCAGUCCAGAUGACCAAAUUGGCUACUACCGAAGAGCUACCAGACGAAUUCGUGGUGGUGACGGUAAAAUGAAAGAUCUCAGUCCAAGAUGGUAUUUCUACUACCUAGGAACUGGGCCAGAAGCUGGACUUCCCUAUGGUGCUAACAAAGACGGCAUCAUAUGGGUUGCAACUGAGGGAGCCUUGAAUACACCAAAAGAUCACAUUGGCACCCGCAAUCCUGCUAACAAUGCUGCAAUCGUGCUACAACUUCCUCAAGGAACAACAUUGCCAAAAGGCUUCUACGCAGAAGGGAGCAGAGGCGGCAGUCAAGCCUCUUCUCGUUCCUCAUCACGUAGUCGCAACAGUUCAAGAAAUUCAACUCCAGGCAGCAGUAGGGGAACUUCUCCUGCUAGAAUGGCUGGCAAUGGCGGUGAUGCUGCUCUUGCUUUGCUGCUGCUUGACAGAUUGAACCAGCUUGAGAGCAAAAUGUCUGGUAAAGGCCAACAACAACAAGGCCAAACUGUCACUAAGAAAUCUGCUGCUGAGGCUUCUAAGAAGCCUCGGCAAAAACGUACUGCCACUAAAGCAUACAAUGUAACACAAGCUUUCGGCAGACGUGGUCCAGAACAAACCCAAGGAAAUUUUGGGGACCAGGAACUAAUCAGACAAGGAACUGAUUACAAACAUUGGCCGCAAAUUGCACAAUUUGCCCCCAGCGCUUCAGCGUUCUUCGGAAUGUCGCGCAUUGGCAUGGAAGUCACACCUUCGGGAACGUGGUUGACCUACACAGGUGCCAUCAAAUUGGAUGACAAAGAUCCAAAUUUCAAAGAUCAAGUCAUUUUGCUGAAUAAGCAUAUUGACGCAUACAAAACAUUCCCACCAACAGAGCCUAAAAAGGACAAAAAGAAGAAGGCUGAUGAAACUCAAGCCUUACCGCAGAGACAGAAGAAACAGCAAACUGUGACUCUUCUUCCUGCUGCAGAUUUGGAUGAUUUCUCCAAACAAUUGCAACAAUCCAUGAGCAGUGCUGACUCAACUCAGGCCUGUUGAGGAUCCUGUGAAUUCGAGCUCCGUCGACAAGCUUGCGGCCGCACUCGAGCACCACCACCACCACCACUGAGAUCCGGCUGCUAACAAAGCCCGAAAGGAAGCUGAGUUGGCUGCUGCCACCGCUGAGCAAUAA'
      },

      namerna:[
        {"value":"18S"},
        {"value":"28S"},
        {"value":"5S"},
        {"value":"ACTG2"},
        {"value":"ADPGK"},
        {"value":"ASPN"},
        {"value":"BNI1"},
        {"value":"C46A5.6"},
        {"value":"CASP8"},
        {"value":"CAT7"},
        {"value":"cbd-1"},
        {"value":"ccbn1"},
        {"value":"CCND1"},
        {"value":"CD247"},
        {"value":"CD274"},
        {"value":"CD44"},
        {"value":"CD47"},
        {"value":"CDR1"},
        {"value":"CLCA2"},
        {"value":"CLN3"},
        {"value":"COL1A1"},
        {"value":"CPT1A"},
        {"value":"Ctnnd1"},
        {"value":"CycB"},
        {"value":"CYCS"},
        {"value":"dao-5"},
        {"value":"DIGIT"},
        {"value":"DMP"},
        {"value":"DNM2"},
        {"value":"DRD1"},
        {"value":"E2"},
        {"value":"ELAVL1"},
        {"value":"EOMES"},
        {"value":"ESCO1"},
        {"value":"FAM174A"},
        {"value":"FAM72B"},
        {"value":"FEM1B"},
        {"value":"FIGNL1"},
        {"value":"Firre"},
        {"value":"FUS"},
        {"value":"GIRGL"},
        {"value":"GLS1"},
        {"value":"GLYATL3"},
        {"value":"GPR34"},
        {"value":"GPR39"},
        {"value":"Grk6"},
        {"value":"GSC-DT"},
        {"value":"HEATR5B"},
        {"value":"HEIH"},
        {"value":"HID2"},
        {"value":"hil-5"},
        {"value":"HNRNPA1"},
        {"value":"HNRNPH3"},
        {"value":"HOGA1"},
        {"value":"hsa-let-7a-1"},
        {"value":"hsa-let-7a-2"},
        {"value":"hsa-let-7a-3"},
        {"value":"hsa-let-7b"},
        {"value":"hsa-let-7c"},
        {"value":"hsa-let-7d"},
        {"value":"hsa-let-7e"},
        {"value":"hsa-let-7f-1"},
        {"value":"hsa-let-7f-2"},
        {"value":"hsa-let-7g"},
        {"value":"hsa-let-7i"},
        {"value":"hsa-miR-125a-5p"},
        {"value":"hsa-miR-1260a"},
        {"value":"hsa-miR-1275"},
        {"value":"hsa-miR-141-3p"},
        {"value":"hsa-miR-191-5p"},
        {"value":"hsa-miR-193b-3p"},
        {"value":"hsa-miR-196b-5p"},
        {"value":"hsa-miR-342-3p"},
        {"value":"hsa-miR-454-3p"},
        {"value":"hsa-miR-484"},
        {"value":"hsa-miR-574-3p"},
        {"value":"hsa-miR-93-3p"},
        {"value":"IL10"},
        {"value":"Kcnq1ot1"},
        {"value":"LAMP1"},
        {"value":"LHFPL6 "},
        {"value":"LPAR4"},
        {"value":"LRBA"},
        {"value":"LYPLAL1"},
        {"value":"MALAT1"},
        {"value":"MAPT"},
        {"value":"MCOLN2"},
        {"value":"miR-125b"},
        {"value":"mmu-miR-202-3p"},
        {"value":"mmu-miR-21a-5p"},
        {"value":"mmu-miR-320-3p"},
        {"value":"Nanog"},
        {"value":"NDUFA13"},
        {"value":"Neat1"},
        {"value":"NORAD"},
        {"value":"nos"},
        {"value":"nos-2"},
        {"value":"ODF2"},
        {"value":"P19 RNA"},
        {"value":"p53"},
        {"value":"pbs-7"},
        {"value":"pgc"},
        {"value":"piR-mmu-48"},
        {"value":"piR-mmu-6"},
        {"value":"piR-mmu-67"},
        {"value":"piR-mmu-88"},
        {"value":"PLA2G4A"},
        {"value":"POLR2A"},
        {"value":"PPP1R3F"},
        {"value":"PRKDC"},
        {"value":"PRPF8"},
        {"value":"PUM1"},
        {"value":"PUM2"},
        {"value":"pyk-1"},
        {"value":"R04D3.2"},
        {"value":"RHOA"},
        {"value":"Rn18s"},
        {"value":"Rn28s1"},
        {"value":"rno-miR-206-3p"},
        {"value":"Rsndom-10"},
        {"value":"SEC53"},
        {"value":"SF3B1"},
        {"value":"Sf9 RNA"},
        {"value":"SHQ1"},
        {"value":"skr-2"},
        {"value":"SLC38A2"},
        {"value":"SLC39A6"},
        {"value":"SLC5A9"},
        {"value":"SMIM3"},
        {"value":"SNHG9"},
        {"value":"SNRNP70"},
        {"value":"SNTN"},
        {"value":"SOSTDC1"},
        {"value":"SPA2"},
        {"value":"SRP"},
        {"value":"SRRM1"},
        {"value":"SRSF1"},
        {"value":"SRSF2"},
        {"value":"STBD1"},
        {"value":"T19H12.2"},
        {"value":"TFRC"},
        {"value":"TJP1"},
        {"value":"TLR8"},
        {"value":"TLR8 "},
        {"value":"TNFAIP6"},
        {"value":"TNFSF11"},
        {"value":"TNFSF11 "},
        {"value":"TP53COR1"},
        {"value":"TP53TG3"},
        {"value":"Trim28"},
        {"value":"TSPAN13"},
        {"value":"TTC17"},
        {"value":"twin"},
        {"value":"U2"},
        {"value":"U2AF2"},
        {"value":"U3"},
        {"value":"UCUCU"},
        {"value":"Vg1"},
        {"value":"VPS29"},
        {"value":"VSIG10"},
        {"value":"Y51F10.2"},
        {"value":"yki"},
        {"value":"znf330.S"},
        {"value":"α-globin"},

      ],
      nameprotein:[
        {"value":"APP"},
        {"value":"ASK3"},
        {"value":"Atx2"},
        {"value":"BRD3"},
        {"value":"C9orf72"},
        {"value":"CAPRIN1"},
        {"value":"CBX2-KRTAP2-3"},
        {"value":"CBX2-RNF2"},
        {"value":"CIRBP"},
        {"value":"Coilin"},
        {"value":"cpeb4"},
        {"value":"DBP1"},
        {"value":"DBP2"},
        {"value":"DBP5"},
        {"value":"dbpA"},
        {"value":"dcp1"},
        {"value":"DCP1A"},
        {"value":"dcp2"},
        {"value":"DDX3X"},
        {"value":"DDX6"},
        {"value":"DeaD"},
        {"value":"DED1"},
        {"value":"DHH1"},
        {"value":"edc3"},
        {"value":"EGFP"},
        {"value":"EIF3B"},
        {"value":"EIF4A1"},
        {"value":"EIF4EBP2"},
        {"value":"eIF4G"},
        {"value":"ELAVL1"},
        {"value":"elF4GII"},
        {"value":"EWSR1"},
        {"value":"fib1"},
        {"value":"fib-1"},
        {"value":"FKBP39"},
        {"value":"FMR1"},
        {"value":"FUS"},
        {"value":"fxr1"},
        {"value":"G3BP1"},
        {"value":"GFP"},
        {"value":"hNPM1"},
        {"value":"HNRNPA1"},
        {"value":"HNRNPA2B1"},
        {"value":"hTIA1"},
        {"value":"HUR"},
        {"value":"IKKbeta"},
        {"value":"K18"},
        {"value":"K25"},
        {"value":"K2R1"},
        {"value":"K3"},
        {"value":"laf-1"},
        {"value":"LATS1"},
        {"value":"LSM4"},
        {"value":"MAPT"},
        {"value":"me31B"},
        {"value":"MED1"},
        {"value":"meg-3"},
        {"value":"MEX-5"},
        {"value":"MMP9"},
        {"value":"MS2 coat protein"},
        {"value":"NONO"},
        {"value":"NOT1"},
        {"value":"NPM1"},
        {"value":"NR2C2"},
        {"value":"nsP3"},
        {"value":"Pab1"},
        {"value":"PAT1"},
        {"value":"pgl-3"},
        {"value":"PRC1"},
        {"value":"Precursor-Arg"},
        {"value":"Precursor-Orn"},
        {"value":"PRM2"},
        {"value":"PSPC1"},
        {"value":"PTBP1"},
        {"value":"Pub1"},
        {"value":"PUM1"},
        {"value":"PUM2"},
        {"value":"R3"},
        {"value":"Rab11a"},
        {"value":"Rbfox1"},
        {"value":"RBM14"},
        {"value":"RH12"},
        {"value":"RH6"},
        {"value":"RH8"},
        {"value":"RhlB"},
        {"value":"RhlE"},
        {"value":"rne"},
        {"value":"RNF2"},
        {"value":"RP3"},
        {"value":"RPL5"},
        {"value":"Rps6"},
        {"value":"RRASL"},
        {"value":"SAFB"},
        {"value":"SFPQ"},
        {"value":"SMCA4"},
        {"value":"SNCA"},
        {"value":"SOP-2"},
        {"value":"spermidine"},
        {"value":"spermine"},
        {"value":"SR8"},
        {"value":"SrmB"},
        {"value":"SRP19"},
        {"value":"SRP54"},
        {"value":"SRP68"},
        {"value":"SRP72"},
        {"value":"SRSF1"},
        {"value":"SRSF2"},
        {"value":"SUB2"},
        {"value":"SUMO-SIM"},
        {"value":"TADBP"},
        {"value":"TAF15"},
        {"value":"TDP-43"},
        {"value":"TFEB"},
        {"value":"TIA-1"},
        {"value":"TIAR"},
        {"value":"TIF4632"},
        {"value":"TIS11B"},
        {"value":"TIS11B-FUS"},
        {"value":"Trnp1"},
        {"value":"TUBA1A"},
        {"value":"U2AF65"},
        {"value":"U2OS lysate"},
        {"value":"UBQLN2"},
        {"value":"Whi3"},
        {"value":"Whi8"},
        {"value":"Y66H1A.4"},
        {"value":"YBX1"},
        {"value":"YFP"},
        {"value":"YTHDF2"},
        {"value":"β-amyloid"},

      ],
      namevirus:[
        {"value":"Influenza A virus"},
        {"value":"Nipah virus"},
        {"value":"Rabies virus"},
        {"value":"Measles virus"},
        {"value":"SARS-CoV-2 virus"},
        {"value":"Lepeophtheirus salmonis virus"},



      ],
      namesets:[],
    }
  },
  methods:{
      changevv(){
          if(this.form.in_vitrovivo=='In vitro'){
            this.form.dis=false
            this.form.components_type=''
          }else {
            this.form.dis=true
            this.form.components_type=null
          }
      }
     ,
    querySearch(queryString, cb) {
      if(this.form.key1=='RNA'){
        this.namesets=this.namerna
      }
      if(this.form.key1=='Protein'){
        this.namesets=this.nameprotein
      }
      if(this.form.key1=='Virus'){
        this.namesets=this.namevirus
      }
      // this.namesets=''
      // if((this.form.key1=='RNA')&&(this.form.components_type=='')&&(this.form.in_vitrovivo=='')&&(this.form.rna_classification=='')&&(this.form.source=='')){
      //   this.namesets=this.namerna
      // }
      // if((this.form.key1=='Protein')&&(this.form.components_type=='')&&(this.form.in_vitrovivo=='')&&(this.form.rna_classification=='')&&(this.form.source=='')){
      //   this.namesets=this.nameprotein
      // }
      // if((this.form.key1=='Virus')&&(this.form.components_type=='')&&(this.form.in_vitrovivo=='')&&(this.form.rna_classification=='')&&(this.form.source=='')){
      //   this.namesets=this.namevirus
      // }

      var namesets = this.namesets;
      var results = queryString ? namesets.filter(this.createFilter(queryString)) : namesets;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (nameset) => {
        return (nameset.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },

    handleSelect(item) {
      this.form.components_type=''
      this.form.in_vitrovivo=''
      this.form.rna_classification=''
      this.form.source=''
      console.log(item);
    },

    search(){
      if(this.form.key1=='RNA'){
        this.form.rnas=this.form.key2
        this.form.Protein=''
        this.form.virus=''
        this.form.rp=''
      }

       if(this.form.components_type=='RNA(s)'){
          this.show=false
        }else {
          this.show=true
        }

      if(this.form.key1=='Protein'){
        this.form.Protein=this.form.key2
        this.form.rnas=''
        this.form.virus=''
        this.form.rp=''
      }
      if(this.form.key1==''){
        this.form.rp=this.form.key2
        this.form.virus=''
        this.form.Protein=''
        this.form.rnas=''
      }
      if(this.form.key1=='Virus'){
        this.form.virus=this.form.key2
        this.form.rp=''
        this.form.Protein=''
        this.form.rnas=''
      }

      search(this.form).then(res => {
        var Div2=document.getElementsByClassName("two")[0];
        Div2.style.display='block'
        var Div3=document.getElementsByClassName("three")[0];
        Div3.style.display='none'

        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr
      })
    }
  ,
    blast(){
      blast(this.bform).then(res => {
        var Div1=document.getElementsByClassName("one")[0];
        Div1.style.display='none'
        var Div4=document.getElementsByClassName("four")[0];
        Div4.style.display='block'

        let arr=[]
        let a=res.list
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].rpsid
          obj.E_value=a[i].e_value
          obj.score=parseFloat(a[i].score)
          obj.Nucleic_acid=a[i].rnas.split('|').join('\n')
          obj.Components_type=a[i].components_type
          obj.RNA_length=a[i].rna_length.split('|').join('\n')
          obj.RNA_len=a[i].rnalenub
          obj.Protein_name=a[i].protein_name.split('|').join('\n')
          obj.Rna_source=a[i].source.split('|').join('\n')
          obj.Rna_classification=a[i].rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.bdata=arr
      })
    },

    example1(){
      this.form.key2=''
      this.form.key1=''
      this.form.components_type=null
      this.form.source=''
      this.form.rna_classification=''
      this.form.in_vitrovivo=''
      this.form.rnas=''
      this.form.Protein=''
      this.form.rp=''
    },
    example2(){
      this.bform.Sequence=''
    },
    example3(){
      this.form.key2='SPA2'
      this.form.key1='RNA'
      this.form.components_type='RNAs + protein'
      this.form.source='Saccharomyces cerevisiae'
      this.form.rna_classification='mRNA'
      this.form.in_vitrovivo='In vitro'
      this.form.rnas=''
      this.form.Protein=''
      this.form.rp=''
      this.form.dis=false
    },
    example4(){
      this.form.key2='DMPK'
      this.form.key1='RNA'
      this.form.components_type='RNA'
      this.form.source='Homo sapiens'
      this.form.rna_classification='mRNA'
      this.form.in_vitrovivo='In vitro'
      this.form.rnas=''
      this.form.Protein=''
      this.form.rp=''
      this.form.dis=false
    },
    example5(){
      this.form.key2='SARS-CoV-2'
      this.form.key1='Virus'
      this.form.components_type=null
      this.form.source='SARS-CoV-2 virus'
      this.form.rna_classification='virus RNA'
      this.form.in_vitrovivo=''
      this.form.rnas=''
      this.form.Protein=''
      this.form.rp=''
    },

    sort_change(column) {
      this.currpage = 1; // 排序后返回第一页
      this.proptype = column.prop; // 将键名prop赋值给变量proptype
      if (column.order === "descending") {
        this.tableData.sort(this.my_desc_sort);
      } else if (column.order === "ascending") {
        this.tableData.sort(this.my_asc_sort);
      }
    },
    //排序方法
    my_desc_sort(a, b) {
      if (a[this.proptype] > b[this.proptype]) {
        return -1
      } else if (a[this.proptype] < b[this.proptype]) {
        return 1
      } else {
        return 0
      } // a["time"] 等价于 a.time
    },
    my_asc_sort(a, b) {
      if (a[this.proptype] > b[this.proptype]) {
        return 1
      } else if (a[this.proptype] < b[this.proptype]) {
        return -1
      } else {
        return 0
      }
    }
    ,
    handleCurrentChange(cpage) {
      this.currpage = cpage;
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
    },

  },
  // mounted() {
  //   this.namesets = this.loadAll();
  // },
}
</script>

<style scoped>
.one{
  margin-bottom: 10px;border:2px solid #eef1f6;display: block;
}
.two{
  max-height: 3000px;border:2px solid #eef1f6;display: none;
}
.three{
  margin-bottom: 10px;border:2px solid #eef1f6;display: block;
}
.four{
  margin-bottom: 10px;border:2px solid #eef1f6;display: none;
}
td{
  font-size: 14px;margin: 0px;padding-left: 30px;padding-right: 30px;
}
input{
  margin-left: 4px;height: 15px;width: 200px;
}
select{
  margin-left: 4px;height: 20px;
}
a{

  text-decoration: none;
  color: #0e63bb;
}
.el-select-dropdown__item{
  font-size: 0.8rem;
}


</style>
<style>
.el-autocomplete-suggestion li{
  font-size: 0.8rem !important;
  line-height: 16px !important
}

</style>